import type { CountryDataset, SupportedCountry } from "@/types/onboarding";

/**
 * Country registry. Datasets are loaded lazily — only the country the doctor
 * actually selects is downloaded, so no worldwide dataset ever reaches the
 * browser. Adding a country means adding one file plus one entry here; no UI
 * component changes.
 */
export const SUPPORTED_COUNTRIES: {
  iso: SupportedCountry;
  name: string;
  dialCode: string;
  flag: string;
}[] = [
  { iso: "IN", name: "India", dialCode: "+91", flag: "🇮🇳" },
  { iso: "GB", name: "United Kingdom", dialCode: "+44", flag: "🇬🇧" },
  { iso: "US", name: "United States", dialCode: "+1", flag: "🇺🇸" },
];

const LOADERS: Record<SupportedCountry, () => Promise<{ default: CountryDataset }>> = {
  IN: () => import("./in"),
  GB: () => import("./gb"),
  US: () => import("./us"),
};

export function isSupportedCountry(iso: string | null | undefined): iso is SupportedCountry {
  return Boolean(iso && iso in LOADERS);
}

export function loadCountryDataset(iso: SupportedCountry): Promise<CountryDataset> {
  return LOADERS[iso]().then((module) => module.default);
}
